
import { rj, SUCCESS, useRunRj } from 'react-rocketjump'
import api from '../api'

const CompletedState = rj()
  .combineReducers({
    params: (state = null, action) => {
      if (action.type === SUCCESS) {
        return action.payload.params[0]
      }
      return state
    },
  })
  .computed({
    data: 'getData',
    loading: 'isLoading',
    error: 'getError',
    dataParams: (s) => s.params,
  })
  .effect({
    name: 'PPR',
    effectCaller: 'configured',
    effect:
      (t) =>
      (params = {}) =>
        api.auth(t).get('/api/products/completed', params),
  })

  export function useCompleted(params) {
    return useRunRj(CompletedState, [params], false)
  }